import IncidentReport from "../fragments/incidentReport";

export default `
query QueryIncidentReportsByServiceProviderId($serviceProviderId: ID!, $from: Float, $to: Float, $after: ID, $includeDeleted: Boolean) {
  queryIncidentReportsByServiceProviderIdStartTimeIndex(serviceProviderId: $serviceProviderId, from: $from, to: $to, after: $after, includeDeleted: $includeDeleted) {
    nextToken
    items ${IncidentReport}
  }
}
`;
